import { createContext, useContext } from "react";
import { ComponentTemplateDto } from "@growth-machine-llc/stridist-api-client";

import React, { useState, ReactNode } from "react";
import { ComponentTemplateDialog } from "../components/component-template/ComponentTemplateDialog";

interface ComponentTemplateDialogType {
  isOpen: boolean;
  componentTemplate: ComponentTemplateDto | null;
  editMode?: boolean;
  openDialog: (
    componentTemplate: ComponentTemplateDto,
    editMode?: boolean,
  ) => void;
  closeDialog: () => void;
  setEditMode?: (editMode: boolean) => void;
}

const ComponentTemplateDialogContext = createContext<
  ComponentTemplateDialogType | undefined
>(undefined);

export const ComponentTemplateDialogProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [componentTemplate, setComponentTemplate] =
    useState<ComponentTemplateDto | null>(null);
  const [editMode, setEditMode] = useState(false);

  //
  //
  // METHODS

  const openDialog = (
    componentTemplate: ComponentTemplateDto,
    editMode?: boolean,
  ) => {
    setIsOpen(true);
    setComponentTemplate(componentTemplate);
    setEditMode(editMode);
  };

  const closeDialog = () => {
    setIsOpen(false);
    setComponentTemplate(null);
    setEditMode(false);
  };

  return (
    <ComponentTemplateDialogContext.Provider
      value={{
        isOpen,
        componentTemplate,
        editMode,
        openDialog,
        closeDialog,
        setEditMode,
      }}
    >
      {isOpen && componentTemplate && (
        <ComponentTemplateDialog
          open={isOpen}
          onClose={closeDialog}
          componentTemplate={componentTemplate}
          componentType={componentTemplate.type}
          componentTemplateLibraryPage
          editMode={editMode}
        />
      )}
      {children}
    </ComponentTemplateDialogContext.Provider>
  );
};

export const useComponentTemplateDialog = (): ComponentTemplateDialogType => {
  const context = useContext(ComponentTemplateDialogContext);
  if (!context) {
    throw new Error(
      "useComponentTemplateDialog must be used within a ComponentTemplateDialogProvider",
    );
  }
  return context;
};
